import type { CourseCashDataProvider } from '../types/course-cash-transaction';

// TODO: Implement real API data provider
// import { CourseCashApiDataProvider } from './course-cash-api-data';

/**
 * Get the Course Cash data provider
 *
 * NOTE: Stub data provider has been removed. Real API implementation pending.
 * Employee app uses mapAssistancesToTransactions() for real data.
 * Admin drawer needs to be migrated to use real API data.
 */
export function getCourseCashDataProvider(): CourseCashDataProvider {
  throw new Error(
    'Stub data provider removed. Use mapAssistancesToTransactions() for employee data. Admin implementation pending.'
  );
}

// Re-export types for convenience
export type { CourseCashDataProvider } from '../types/course-cash-transaction';
